// #region IMPORT
import urlcat from "urlcat";
import {
  IAdminCreateApiRequest,
  IAdminCreateApiResponse,
  IAdminListApiRequest,
  IAdminListApiResponse,
  IAdminPermissionRequest,
  IAdminPermissionResponse,
  IAdminUpdateApiRequest,
  IAdminUpdateApiResponse,
} from "../../../../../model/user/admin/admin.model";
import { Builder, MD, QD } from "../../../api.baseQuery";
import { IEndpointTags } from "../../../api.endpoint";
// #endregion

// #region INTERFACES
export type AdminEndpoint = {
  getAdmins: QD<IAdminListApiRequest, IAdminListApiResponse>;
  getAdminPermissions: QD<IAdminPermissionRequest, IAdminPermissionResponse>;
  createAdmin: MD<IAdminCreateApiRequest, IAdminCreateApiResponse>;
  updateAdmin: MD<IAdminUpdateApiRequest, IAdminUpdateApiResponse>;
};
// #endregion

// #region ENDPOINT
export const adminTagTypes: IEndpointTags<AdminEndpoint> = {
  getAdmins: "get-admins",
  getAdminPermissions: "get-admin-permissions",
  createAdmin: "create-admin",
  updateAdmin: "update-admin",
};

export const adminEndpoint = (builder: Builder): AdminEndpoint => ({
  getAdmins: builder.query({
    query: (param) => urlcat("/admins", param),
    providesTags: [adminTagTypes.getAdmins],
  }),
  getAdminPermissions: builder.query({
    query: ({ id, ...body }) => ({
      url: urlcat(`/admins/${id}/permissions`, body),
      method: "GET",
    }),
    providesTags: [adminTagTypes.getAdminPermissions],
  }),
  createAdmin: builder.mutation({
    query: (body) => ({
      url: `/admins`,
      method: "POST",
      body,
    }),
    invalidatesTags: [adminTagTypes.getAdmins],
  }),
  updateAdmin: builder.mutation({
    query: ({ id, ...body }) => ({
      url: `/admins/${id}`,
      method: "PATCH",
      body,
    }),
    invalidatesTags: [adminTagTypes.getAdmins],
  }),
});
// #endregion
